// extracted by mini-css-extract-plugin
export default {"bar":"SocialMediaBar_bar__g2j5O"};